import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=a5701b0e&"
import script from "./appointment.vue?vue&type=script&lang=js&"
export * from "./appointment.vue?vue&type=script&lang=js&"
import style0 from "./appointment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports